export default __webpack_public_path__ + "static/media/04_s.88cd16d0.png";